import React, { useState, useEffect, useRef } from 'react'
import { Button, Form, Input, message, Radio, Modal } from 'antd'
import {
  shoppingCartCheckout,
  checkoutZenotiGuest,
  checkoutZenotiAddCard,
} from '@services/api.shoppingCart.service'
import { useNavigate } from 'react-router-dom'
import { GoPlus } from 'react-icons/go'
import AddCreditCard from './AddCreditCard'
import { FaCircleCheck } from 'react-icons/fa6'

const style = {
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
}

export default function CartPersonalInfoForm({
  setIsCheckout,
  userinfo,
  isCheckout,
  selectedStore,
  shoppingCart,
  isZenoti,
  setIsZenoti,
}) {
  const navigate = useNavigate()
  const [formRef] = Form.useForm()
  const [zenotiUser, setZenotiUser] = useState(null)
  const [isOpen, setIsOpen] = useState(false)
  const [isRefresh, setIsRefresh] = useState(true)
  const [addCardData, setAddCardData] = useState(null)
  const [accountId, setAccountId] = useState(null)
  const [isFinished, setIsFinished] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const business = shoppingCart?.data?.data?.find(
    item => item._id === selectedStore,
  )?.business

  console.log('shoppingCart business:', business)

  useEffect(() => {
    if (!isRefresh) return
    const fetchZenotiUser = async () => {
      try {
        const res = await checkoutZenotiGuest({
          business_id: selectedStore,
        })
        console.log('checkoutZenotiGuest res', res)
        setZenotiUser(res?.data)
        //set the last one
        setAccountId(
          res?.data?.accounts[res?.data?.accounts.length - 1]?.account_id,
        )
      } catch (error) {
        console.log('checkoutZenotiGuest error', error)
      }
      setIsRefresh(false)
    }
    fetchZenotiUser()
  }, [selectedStore, isRefresh])

  useEffect(() => {
    if (formRef) {
      formRef.setFieldsValue({
        email: userinfo?.username,
        firstName: userinfo?.firstName,
        lastName: userinfo?.lastName,
        phone: userinfo?.phone,
      })
    }
  }, [formRef, userinfo])

  const handleSubmit = async () => {
    const hide = message.loading('Checkout in progress...')
    try {
      const res = await shoppingCartCheckout({
        business_id: selectedStore,
        payment_account_id: accountId,
        shippingInfo: formRef?.getFieldsValue(),
      })
      console.log('checkout res', res)
      hide()
      setIsSubmitting(true)
      setIsFinished(true)
      // console.log('formRef111', accountId, formRef?.getFieldsValue())
      setTimeout(() => {
        setIsSubmitting(false)
      }, 2000)
      // pos_checkout_id
    } catch (error) {
      console.log('checkout error', error)
      hide()
      message.error(
        'Checkout failed: ' + error?.data?.message || 'Please try again',
      )
    }
  }

  const handleAddCard = async () => {
    try {
      const res = await checkoutZenotiAddCard({
        business_id: selectedStore,
      })
      console.log('checkoutZenotiAddCard res', res)
      if (res?.data?.success) {
        setAddCardData(res?.data)
        setIsOpen(true)
      } else {
        message.error(res?.data?.error?.message || 'Failed to get the link of the payment page')
      }
    } catch (error) {
      console.log('checkoutZenotiAddCard error', error)
    }
  }

  return (
    <>
      <AddCreditCard
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        addCardData={addCardData}
        setIsRefresh={setIsRefresh}
      />
      <Modal
        width={600}
        title={'Checkout'}
        centered
        open={isFinished}
        onOk={() => {
          navigate('/my-fitzba')
        }}
        onCancel={() => {
          navigate('/my-fitzba')
        }}
        // hide footer
        footer={null}
      >
        <div className='flex flex-col items-start justify-center gap-5'>
          <div className='flex items-center gap-3'>
            <FaCircleCheck
              size={40}
              className='text-fitzba-bright-gold-static'
            />
            <p>
              Thank you for placing your order! <br />
              You will receive an email once the store confirms it.
            </p>
          </div>
          <div className='flex w-full items-center justify-center gap-5 smsize:gap-2'>
            <button
              type='button'
              onClick={() => {
                navigate('/')
              }} // Redirect to home page
              className='flex w-full smsize:px-1 cursor-pointer justify-center rounded-full border-2 border-fitzba-bright-gold-static bg-white px-10 py-[6px] uppercase text-fitzba-bright-gold-static hover:bg-fitzba-bright-gold-static hover:text-white'
            >
              Continue Shopping
            </button>
            <button
              type='button'
              onClick={() => {
                navigate('/my-fitzba')
              }}
              className='flex w-full smsize:px-1 cursor-pointer justify-center rounded-full border-2 border-fitzba-bright-gold-static bg-fitzba-bright-gold-static px-10 py-[6px] uppercase text-white hover:bg-white hover:text-fitzba-bright-gold-static'
            >
              View Order
            </button>
          </div>
        </div>
      </Modal>
      <div className='cart-content-header'>
        <h3>Checkout</h3>
        <p>Please complete the following information.</p>
      </div>
      <div className='flex-1'>
        <h3 className='mb-2 text-[22px] font-[300]'>Personal information</h3>
        <Form
          form={formRef}
          layout='vertical'
          onFinish={values => {
            handleSubmit(values)
          }}
        >
          <div className='flex w-full items-center gap-4'>
            <Form.Item
              label='Email'
              name='email'
              // hasFeedback
              className='w-full'
            >
              <Input
                size='large'
                className='rounded-full border-black'
                placeholder='First Name'
                allowClear
                disabled
                type='email'
              />
            </Form.Item>
            <Form.Item
              label='Phone Number'
              name='phone'
              rules={[
                {
                  required: true,
                  message: 'Please input phone number',
                },
              ]}
              hasFeedback
              className='w-full'
            >
              <Input
                size='large'
                className='rounded-full border-black'
                placeholder='Last Name'
                allowClear
              />
            </Form.Item>
          </div>
          <div className='flex w-full items-center gap-4'>
            <Form.Item
              label='First Name'
              name='firstName'
              rules={[
                {
                  required: true,
                  message: 'Please input your first name',
                },
              ]}
              hasFeedback
              className='w-full'
            >
              <Input
                size='large'
                className='rounded-full border-black'
                placeholder='First Name'
                allowClear
              />
            </Form.Item>
            <Form.Item
              label='Last Name'
              name='lastName'
              rules={[
                {
                  required: true,
                  message: 'Please input last name',
                },
              ]}
              hasFeedback
              className='w-full'
            >
              <Input
                size='large'
                className='rounded-full border-black'
                placeholder='Last Name'
                allowClear
              />
            </Form.Item>
          </div>
        </Form>
      </div>
      <div className='flex-1'>
        <div className='flex items-center gap-3'>
          <h3 className='mb-2 text-[22px] font-[300]'>Payment method</h3>
          <Button onClick={() => setIsRefresh(true)}>Refresh</Button>
        </div>
        <div className='border-fitzba-light-gray flex flex-col gap-3 rounded-lg border p-5'>
          <h4>Your credit cards</h4>
          <Radio.Group style={style} value={accountId}>
            {zenotiUser?.accounts?.map((card, index) => (
              <Radio key={index} value={card?.account_id}>
                {card?.card_logo} ending in {card?.last_four}
              </Radio>
            ))}
          </Radio.Group>
          <div
            className='flex cursor-pointer items-center gap-2'
            onClick={handleAddCard}
          >
            <GoPlus size={20} />
            Add a credit or debit card
          </div>
        </div>
        <div className='mt-3 flex w-full items-center gap-4 text-red-500'>
          Note: You will not be charged until the store confirms the order.
        </div>
      </div>
      <div className='mt-3 flex justify-end gap-5'>
        <button
          type='button'
          onClick={() => setIsZenoti(false)}
          className='flex w-fit cursor-pointer justify-center rounded-full border-2 border-fitzba-bright-gold-static bg-white px-10 py-[6px] uppercase text-fitzba-bright-gold-static hover:bg-fitzba-bright-gold-static hover:text-white'
        >
          Back
        </button>
        <button
          type='submit'
          disabled={(accountId ? false : true) || isSubmitting}
          onClick={handleSubmit}
          className='flex w-fit cursor-pointer justify-center rounded-full border-2 border-fitzba-bright-gold-static bg-fitzba-bright-gold-static px-10 py-[6px] uppercase text-white hover:bg-white hover:text-fitzba-bright-gold-static disabled:border-gray-500 disabled:bg-gray-500 disabled:text-white'
        >
          {isSubmitting ? 'Processing...' : 'Continue'}
        </button>
      </div>
    </>
  )
}
